document.addEventListener('scroll', function (event) {
    // 防止视频被暂停
    document.querySelectorAll("video:not(.padasnap-gallery-video)").forEach(video => {
        if (video.paused) {
            video.play().then(() => {
            }).catch(error => {
                console.error("播放失败:", error);
            });
        }
    })



    // 滑动到底部，加入购物车的悬浮层隐藏
    let cus_product_sticky_cart = document.querySelector(".cus_product-sticky-cart")
    if (!cus_product_sticky_cart) return;
    if (window.innerHeight + document.documentElement.scrollTop + 50 >= document.documentElement.scrollHeight) {
        cus_product_sticky_cart.classList.add('cus_product-sticky-cart_downturn')
    } else {
        cus_product_sticky_cart.classList.remove('cus_product-sticky-cart_downturn')
    }

});

;(() => {
  const frameSelector = '.rio-media-gallery iframe[id^="pwzrswiper-img-frame-"]';
  const videoSelector = '.rio-media-gallery video.padasnap-gallery-video';

  function replacePlayer(frame) {
    let payload;
    try {
      const url = new URL(frame.getAttribute('src'), document.baseURI);
      if (url.origin !== 'https://pwzcdn.com' || url.pathname !== '/rio-store/prod/video-player/index.html') return;
      payload = JSON.parse(url.searchParams.get('payload'));
    } catch {
      return;
    }

    const source = payload?.sources?.find(item => item.mimeType === 'video/mp4' && item.url);
    if (!source) return;

    let sourceUrl;
    try {
      sourceUrl = new URL(source.url, document.baseURI);
      if (sourceUrl.protocol !== 'https:') return;
    } catch {
      return;
    }

    const parent = frame.parentElement;
    if (!parent) return;
    let video = parent.querySelector('video.padasnap-gallery-video');
    if (video && video.dataset.source !== sourceUrl.href) {
      video.pause();
      video.remove();
      video = null;
    }

    if (!video) {
      video = document.createElement('video');
      video.className = 'padasnap-gallery-video';
      video.dataset.source = sourceUrl.href;
      video.controls = true;
      video.preload = 'none';
      video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('controlslist', 'nodownload');
      video.loop = Boolean(payload.loop);
      video.muted = true;
      video.defaultMuted = true;
      video.tabIndex = 0;
      if (payload.poster) video.poster = payload.poster;
      const title = frame.title || document.querySelector('main h1')?.textContent?.trim();
      if (title) video.setAttribute('aria-label', title);
      const mediaSource = document.createElement('source');
      mediaSource.src = sourceUrl.href;
      mediaSource.type = source.mimeType;
      video.append(mediaSource);
      video.addEventListener('touchstart', () => video.blur(), { passive: true });
      video.addEventListener('play', () => {
        const slide = video.closest('.pwzrswiper-slide');
        if (slide && !slide.classList.contains('pwzrswiper-slide-active')) {
          video.pause();
          return;
        }
        document.querySelectorAll(videoSelector).forEach(other => {
          if (other !== video) other.pause();
        });
      });
      parent.append(video);
    }

    frame.dataset.padasnapNativeVideo = '';
    frame.hidden = true;
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.src = 'about:blank';
  }

  function reconcile() {
    document.querySelectorAll(frameSelector).forEach(replacePlayer);
    document.querySelectorAll(videoSelector).forEach(video => {
      const slide = video.closest('.pwzrswiper-slide');
      if (slide && !slide.classList.contains('pwzrswiper-slide-active')) video.pause();
    });
  }

  function init() {
    const root = document.querySelector('main');
    if (!root || root.hasAttribute('data-padasnap-video-swipe-ready')) return;
    root.dataset.padasnapVideoSwipeReady = '';
    let queued = false;
    const observer = new MutationObserver(records => {
      if (queued || !records.some(record => {
        const target = record.target;
        return target instanceof Element && (target.closest('.rio-media-gallery') ||
          [...record.addedNodes].some(node => node instanceof Element &&
            (node.matches('.rio-media-gallery') || node.querySelector('.rio-media-gallery'))));
      })) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        reconcile();
      });
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src'] });
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
